export const MapPreview = ({ point, testid = "map-preview", className = "" }) => {
  if (!point?.lat) return null;
  const d = 0.012;
  const bbox = [point.lon - d * 1.6, point.lat - d, point.lon + d * 1.6, point.lat + d].map((n) => n.toFixed(5)).join("%2C");
  return (
    <div data-testid={testid} data-lat={point.lat} data-lon={point.lon} className={`ff-rise rounded-xl overflow-hidden border border-[#27272A] ${className}`}>
      <iframe key={`${point.lat},${point.lon}`} title={point.label || "map"} loading="lazy" className="w-full h-44 sm:h-52 block grayscale-[35%] invert-[88%] hue-rotate-180"
        src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${point.lat.toFixed(5)}%2C${point.lon.toFixed(5)}`} />
      <p className="px-3 py-2 text-xs font-semibold text-[#CBD5E1] bg-[#0A0A0A] truncate">📍 {point.label}</p>
    </div>
  );
};
